<template>
  <div>
    <a href="https://iouu.com.br" target="_blank" class="logo"
      ><img src="../assets/images/logo-light.svg" alt="logo IOUU"
    /></a>

    <div class="image">
      <img
        class="imagem"
        src="../assets/images/img-conta.png"
        alt="imagem login"
      />
      <div class="box">
        <img src="../assets/images/icon-gif.svg" alt="icone" />

        <div class="text">
          <p class="txt">
            Transparência é o que faz a plataforma funcionar de maneira rápida,
            simples e responsável.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
$verde: #41d3bd;
$azul: #21247f;
$azul-sec: #3b46c4;
$branco: #ffffff;
$cinza-claro: #e9eafa;
$cinza-medio: #818495;
$cinza-escuro: #2c3236;

.logo {
  position: absolute;
  top: 42px;
  left: 180px;
  z-index: 3;
  left: 15px;
}
.image {
  position: relative;
  width: 772px;
  height: 682px;
  left: -185px;
  .imagem {
    width: 100%;
    object-fit: cover;
    height: 100%;
    position: absolute;
  }
  .box {
    padding: 35px 56px 27px;
    position: absolute;
    right: 36px;
    bottom: 95px;
    background-color: $branco;
    border-radius: 8px;
    width: 436px;
    height: 139px;
    display: flex;
    align-items: flex-start;
    img {
      margin-right: 21px;
      width: 35px;
      height: 35px;
    }
    .txt {
      &:first-child {
        color: $verde;
      }
      &:last-child {
        color: $azul;
        font-size: 0.93rem;
      }
    }
  }

  &:after {
    content: "";
    position: absolute;
    background: url(../assets/images/after-login.svg) no-repeat;
    background-size: cover;
    width: 570px;
    height: 270px;
    bottom: -180px;
    left: 140px;
  }
}

.image {
  left: -157px;
  width: 772px;
  height: 599px;
  .box {
    z-index: 10;
    padding: 30px 50px;
    right: initial;
    left: 185px;
    bottom: 48px;
  }
  &:after {
    content: "";
    position: absolute;
    background: url(../assets/images/after-conta.svg) no-repeat;
    background-size: cover;
    width: 842px;
    height: 498px;
    bottom: -45px;
    left: 0px;
  }
}

.txt {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: 1.125rem; //18
  line-height: 135%;
  letter-spacing: 0.005em;
  color: $cinza-escuro;

  @media (max-width: 560px) {
    font-size: 0.875rem; //14
  }
}

@media (max-width: 1440px) {
  .image {
    left: -100px;
  }
  .image {
    left: -74px;
    &:after {
      left: -50px;
    }
  }
}
@media (max-width: 1336px) {
  .image {
    left: -80px;
  }
  .image {
    left: -41px;
    width: 705px;

    &:after {
      left: -94px;
    }
  }
}

@media (max-width: 1200px) {
  .image {
    height: 575px;
    width: 639px;
    &:after {
      left: -140px;
    }
  }
}

@media (max-width: 1050px) {
  .container {
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .logo {
    display: none;
  }
  .image {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LoginBanner.vue